export function formatMinutesToTime(minutes = "") {
    minutes = Number(minutes)

    if (isNaN(minutes)) return ""

    let h = String(Math.floor(minutes / 60)).padStart(2, '0'),
        m = String(minutes - (h * 60)).padStart(2, '0')
    return `${h}:${m}`
}

export function formatToMinutes(time = "") {
    console.log({ time });
    if (!time) {
        time = ''
    }

    const hours = Number(time.split?.(":")[0] || 0)
    const minutes = Number(time.split?.(":")[1] || 0)

    if (!isNaN(hours) && !isNaN(minutes)) {
        return (hours * 60) + minutes
    } else {
        return 0
    }

}